import styled from 'styled-components';

export const EquipmentIcon = styled.img`
  max-width: 50px;
  border-radius: 10px;
`;
